/** Applies embed-write-guard.ts in the assistant's hidden frame, as a side effect of import. */
import { installEmbedWriteGuard, isAssistantViewFrame } from "./embed-write-guard";

if (isAssistantViewFrame(window.location.search)) {
	installEmbedWriteGuard(window);
}
